import api, { formatApiError } from "@/lib/api";
import { AlertTriangle, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";

const SOURCES = { note: "Note del lavoro", extra: "Aggiunta", inspection: "Ispezione furgone", attendance: "Nota presenze" };
const CATS = { danno: "Danno", infortunio: "Infortunio", lamentela: "Lamentela cliente", altro: "Problema" };

export default function IncidentAlerts({ job, onChanged }) {
  const open = (job.incident_alerts || []).filter((a) => !a.resolved);
  if (open.length === 0) return null;

  const resolve = async (id) => {
    try {
      const { data } = await api.post(`/jobs/${job.id}/incidents/${id}/resolve`);
      onChanged({ ...job, incident_alerts: data.incident_alerts });
      toast.success("Segnalazione gestita");
    } catch (e) { toast.error(formatApiError(e)); }
  };

  return (
    <section className="bg-rose-50 border-2 border-rose-300 rounded-2xl p-5" data-testid="incident-alerts">
      <h3 className="font-display font-bold text-rose-900 flex items-center gap-2 mb-3">
        <AlertTriangle className="w-5 h-5" /> Possibili danni o incidenti ({open.length})
      </h3>
      <ul className="space-y-2">
        {open.map((a) => (
          <li key={a.id} className="bg-white border border-rose-200 rounded-xl p-3 flex flex-col sm:flex-row sm:items-start gap-3" data-testid={`incident-alert-${a.id}`}>
            <div className="flex-1 min-w-0">
              <div className="flex flex-wrap items-center gap-2 text-[11px] font-bold uppercase tracking-wider">
                <span className="bg-rose-600 text-white rounded-full px-2 py-0.5" data-testid={`incident-category-${a.id}`}>{CATS[a.category] || "Problema"}</span>
                <span className="text-rose-700">{SOURCES[a.source] || a.source}</span>
                <span className="text-slate-400 normal-case font-mono">{a.author} · {a.created_at?.slice(0, 16).replace("T", " ")}</span>
              </div>
              <p className="mt-1.5 text-sm text-slate-800 whitespace-pre-wrap">{a.text}</p>
            </div>
            <button
              onClick={() => resolve(a.id)}
              className="shrink-0 inline-flex items-center gap-1.5 text-xs font-semibold bg-emerald-600 hover:bg-emerald-700 text-white rounded-lg px-3 py-2 transition-colors"
              data-testid={`resolve-incident-${a.id}`}
            >
              <CheckCircle2 className="w-4 h-4" /> Gestito
            </button>
          </li>
        ))}
      </ul>
    </section>
  );
}
